import Vue from 'vue'
import Vuex from 'vuex'
import { VuexModule } from 'vuex-module-decorators'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '@/utils/oidc'
Vue.use(Vuex)

const oidc = new VuexModule(
  vuexOidcCreateStoreModule(oidcSettings, { namespaced: true })
)
export { oidc }
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    oidc
  }
})
